<template>
  
  <div>
      <section id="united_nations">
        <UdhrIntro :items="items.udhr_section"></UdhrIntro>
      </section>

      <section id="udhr_instructions">
        <UdhrInstructions :items="items.udhr_section"></UdhrInstructions>
      </section>

      <section id="udhr">
        <UdhrRightsSelector :items="items.related_udhr_articles"></UdhrRightsSelector>
      </section>
  </div>
  
</template>
<script>
import UdhrIntro from '@/components/udhr/UdhrIntro.vue'
import UdhrInstructions from '@/components/udhr/UdhrInstructions.vue'
import UdhrRightsSelector from '@/components/udhr/UdhrRightsSelector.vue'

export default {
  name: 'Udhr',
  components: {
      UdhrIntro,
      UdhrInstructions,
      UdhrRightsSelector,
  },
  props: [
    'items',
  ]
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .brown-bg {
        background-color: #382e2b;
        color: white;
    }

    .article-receptacle {
        background-color: #2f2523;
        height: 200px;
        width: 200px;
    }
</style>
